import { Vue, Component, Prop } from 'vue-property-decorator';
import { ngInject } from '@/vue/decorators/angular-interop';

@Component
class RouterLink extends Vue {
    @Prop({ type: String, default: 'a' })
    tag;
    /**
     * Legacy angular:
     * <a ui-sref="base.someRoute({id: installation.id})" />
     * Becomes in vue:
     * <router-link :to="{name: 'base.someRoute', params: {id: installation.id}}" />
     */
    @Prop()
    to;

    render(h) {
        return h(this.tag, this.bindings, this.$slots.default);
    }

    get isAnchor() {
        return this.tag === 'a';
    }

    get parsedTargetState() {
        if (!this.to) return null;
        const route = typeof this.to === 'string' ? { name: this.to } : this.to;
        const state = this.$uiRouter.stateRegistry.get(route.name);
        const params = route.params || {};
        const href = this.$uiRouter.stateService.href(state, params);
        return { state, params, href };
    }

    get bindings() {
        const data = {
            attrs: { ...this.$attrs },
            on: {},
        };
        const { state, params, href } = this.parsedTargetState;
        if (this.isAnchor) {
            data.attrs.href = href;
        }
        data.on.click = e => {
            if (guardEvent(e)) {
                this.$uiRouter.stateService.go(state, params);
            }
        };
        return data;
    }

    @ngInject()
    $uiRouter;
}

// Based on https://github.com/vuejs/vue-router/blob/83920c93333486bb94edfb409118702d645c81bf/src/components/link.js#L165-L182
function guardEvent(e) {
    // don't redirect with control keys
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    // don't redirect when preventDefault called
    if (e.defaultPrevented) return;
    // don't redirect on right click
    if (e.button !== undefined && e.button !== 0) return;
    // don't redirect if `target="_blank"`
    if (e.currentTarget && e.currentTarget.getAttribute) {
        const target = e.currentTarget.getAttribute('target');
        if (/\b_blank\b/i.test(target)) return;
    }
    // this may be a Weex event which doesn't have this method
    if (e.preventDefault) {
        e.preventDefault();
    }
    return true;
}

// One of the few globally registered component, but because that is the norm for vue-router we do it

export default RouterLink;
